import { NavLink } from "react-router-dom";

import { useVesselPath } from "@/lib/hooks";

/**
 * What am I logging — a test, or something I poured in?
 *
 * These are two different jobs that happen at the same railing, so they belong
 * one tap apart. Chemicals lived under More until now, which put a screen and a
 * scroll between "I just added a gallon of chlorine" and recording it.
 *
 * Rendered as an underlined tab bar rather than the pill used for quick/full
 * inside the reading form. That form stacks its own pill directly beneath this,
 * and two identical controls one above the other read as one broken four-way
 * choice. Different shapes say different things: these switch *screen*, the
 * pill switches an *option* on the screen you are already on.
 */
const TABS = [
  { to: "/log", label: "Reading", end: true },
  { to: "/log/chemicals", label: "Chemicals", end: false },
];

export default function LogModeTabs() {
  const vp = useVesselPath();
  return (
    <nav
      aria-label="What to log"
      className="mb-5 flex gap-1 border-b border-(--color-border-subtle)"
    >
      {TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={vp(tab.to)}
          end={tab.end}
          className={({ isActive }) =>
            [
              // -1px pulls the active underline onto the container's border so
              // they read as one line rather than two.
              "-mb-px flex-1 border-b-2 px-3 py-2.5 text-center text-sm font-medium",
              isActive
                ? "border-(--color-brand) text-(--color-ink)"
                : "border-transparent text-(--color-ink-muted)",
            ].join(" ")
          }
        >
          {tab.label}
        </NavLink>
      ))}
    </nav>
  );
}
